<template>
    <div class="container">
        <div class="header">
            个人会员分包服务规则
        </div>
        <div class="content">
            <p>本平台作为新经济综合服务平台，在承接企业会员发布的灵活、零星的外包服务需求后可将其中的一项或多项分包给本平台的个人会员，个人会员可依本规则承接服务项目。</p>
            <div class="sub-title">
                <span class="ui-interval">第一条</span>任务的生成
            </div>
            <p>
                <span class="ui-interval">1.1</span>
                本平台将企业会员《服务需求发布单》中的服务内容分包的，向该企业会员及拟分包
的个人会员发送《服务需求确认单》，经该企业会员及拟分包的个人会员确认后任务生成。会员根据本平台系统设置选择确认方式。
            </p>
            <p>
                <span class="ui-interval">1.2</span>
                个人会员允许本平台出于拟分包的需要，向提交《服务需求发布单》的企业会员提供
个人会员在本平台的注册信息。提交《服务需求发布单》的企业会员对本平台拟分包
的个人会员有考察要求的，有承接分包任务意向的个人会员应当予以配合。
            </p>
            <p>
                <span class="ui-interval">1.3</span>
                个人会员有如下情形之一的，不得确认本平台发送的《服务需求确认单》：<br>
                （1）与作为服务需求方的企业会员具有劳动/劳务合同关系或其他类似法律关系的人员；<br>
                （2）作为服务需求方的企业会员或其关联方的法定代表人、董事、监事、股东；<br>
                （3）不具备实施《服务需求确认单》中服务内容的条件及能力的。
            </p>
            <p>
                <span class="ui-interval">1.4</span>
                任务生成后，相关方方可按照《服务需求确认单》实施任务。除非基于法律明确规定或本规则明确规定的事由，分包会员不得单方中止、终止已生成的任务。
            </p>
            <div class="sub-title">
                <span class="ui-interval">第二条</span>任务的实施
            </div>
            <p>
                <span class="ui-interval">2.1</span>
                已生成的任务，除非本规则另有规定，分包会员均应按照已确认的《服务需求确认单》实施。
            </p>
            <p>
                <span class="ui-interval">2.2</span>
                本平台分包的任务，由分包会员直接向发包会员提供服务并输出服务成果，由发包会员直接进行确认，视为本平台向发包会员的实际交付。
            </p>
            <p>
                <span class="ui-interval">2.3</span>
                如发包会员与分包会员在《服务需求确认单》的任务之外另有服务或其他约定安排的，本平台不就未参与的安排承担任何责任。
            </p>
            <p>
                <span class="ui-interval">2.4</span>
                分包会员提交服务成果后，发包会员向本平台出具相应《服务成果确认书》的，本平台转发给分包会员予以确认。分包会员有异议的，应当于收到《服务成果确认书》后二日内向本平台提出（异议应当附有明确依据），分包会员在上述期限内未确认亦未按约定提出异议的，视为默认《服务成果确认书》全部内容。
            </p>
            <p>
                <span class="ui-interval">2.5</span>
                分包会员提交服务成果后三日内仍未收到本平台转发发包会员《服务成果确认书》的，有权向本平台客服查询并按照附件格式提交《服务成果确认书》，由本平台转给发包会员确认，发包会员对于分包会员提交的《服务成果确认书》有异议的，按照本规则的异议解决条款处理。
            </p>
            <p>
                <span class="ui-interval">2.6</span>
                发包会员为任务实施而提供给分包会员使用的一切商标、专利、著作权、专有技术等知识产权均归发包会员享有，分包会员不得侵犯，并且保证提交的服务成果不侵犯他人的知识产权。
            </p>
            <p>
                <span class="ui-interval">2.7</span>
                分包会员在任务实施中所形成的技术成果或其他知识产权，除非《服务需求确认单》中另有规定，均归属于发包会员，包括但不限于：<br>
                （1）在服务中形成的或作为服务成果的发明创造，申请专利的权利属于发包会员。<br>
                （2）在服务中形成的或作为服务成果的技术秘密，使用权、转让权以及利益均归发包会员。<br>
                （3）在服务中形成的或作为服务成果的作品，著作权归发包会员享有（本规则所称“作品”以我国《著作权法》对“作品”的定义为准）。
            </p>
            <p>
                <span class="ui-interval">2.8</span>
                分包会员应当作为从事生产经营的个人依据本规则提供经济服务，分包会员与本平台不构成劳动合同关系或雇佣劳务关系。
            </p>
            <p>
                <span class="ui-interval">2.9</span>
                分包会员在任务实施过程中，应当遵守法律法规，勤勉尽责，尽力维护本平台及发包会员的合法权益。
            </p>
            <p>
                <span class="ui-interval">2.10</span>
                分包会员未按照本规则履行义务，导致发包会员向本平台主张权利的，分包会员应当立即采取补救措施予以解决，由此给本平台造成损失的按照《会员注册协议》中的违约责任条款予以赔偿。分包会员未按照本规则履行义务导致本平台向发包会员承担责任的，按照《会员注册协议》中的违约责任条款赔偿由此给本平台造成的全部损失。
            </p>
            <div class="sub-title">
                <span class="ui-interval">第三条</span>任务的报酬
            </div>
            <p>
                <span class="ui-interval">3.1</span>
                本平台按照本规则的规定支付分包任务的服务报酬，服务报酬的计价方式载于《服务需求确认单》。本平台无义务在约定的服务报酬之外支付任何费用。
            </p>
            <p>
                <span class="ui-interval">3.2</span>
                服务报酬由本平台以银行转账形式向分包会员支付。个人会员应当于注册时提交真实、准确、完整的银行账户信息。
            </p>
            <p>
                <span class="ui-interval">3.3</span>
                已完成的任务，分包会员应当于发包会员确认《服务成果确认书》后二日内向本平台按照系统格式提交《服务报酬结算申请单》，《服务报酬结算申请单》与发包会员《服务成果确认书》结算内容不一致的，本平台有权不予确认。
            </p>
            <p>
                <span class="ui-interval">3.4</span>
                本平台确认分包会员提交的《服务报酬结算申请单》后三日内，向分包会员支付实际结算的服务报酬。分包会员对其依据本规则取得的服务报酬按照经营所得依法纳税。
            </p>
            <p>
                <span class="ui-interval">3.5</span>
                分包会员收取服务报酬应当向本平台开具增值税<span class="underline letter-2"></span>发票。本平台开票信息如下：<br>
                公司名称：<span class="underline letter-20"></span><br>
                地址：<span class="underline letter-20"></span><br>
                税号：<span class="underline letter-20"></span><br>
                电话： <span class="underline letter-20"></span><br>
                开户行：<span class="underline letter-20"></span><br>
                账号：<span class="underline letter-20"></span>
            </p>
            <p>
                <span class="ui-interval">3.6</span>
                本平台有权按照有关税收政策及主管税务机关的要求，在支付服务报酬时为分包会员足额代扣代缴个人所得税，如分包会员委托（以系统格式的授权委托书为准），本平台可为分包会员代理增值税发票开具及申报，代扣代缴增值税及规费等税费事务。
            </p>
            <p>
                <span class="ui-interval">3.7</span>
                分包会员擅自中止、终止任务或因违约而被本平台取消任务的，不得向本平台主张支付服务报酬，给本平台造成损失的，按照《会员注册协议》中的违约责任条款予以赔偿。
            </p>
            <div class="sub-title">
                <span class="ui-interval">第四条</span>异议的解决
            </div>
            <p>
                <span class="ui-interval">4.1</span>
                任务相关方对于服务成果或结算依据本规则提出的有效异议，由本平台客服专员与任务相关各方沟通解决，如自异议提出之日起<span
                class="underline letter-2"></span>日内仍未能达成一致的，则本平台对于异议涉及的任务于线上关闭封存，转由线下解决。
            </p>
            <p>
                <span class="ui-interval">4.2</span>
                上述异议转由线下解决的，如相关方经协商就异议解决达成一致，可于线下签署有关协议；经协商仍不能达成一致的，按照《会员注册协议》约定的争议解决方式处理。
            </p>
            <div class="sub-title">
                <span class="ui-interval">第五条</span>任务的中止与取消
            </div>
            <p>
                <span class="ui-interval">5.1</span>
                分包会员有下列情形之一的，本平台有权取消该分包会员实施的部分或全部任务： <br>
                （1） 与发包会员串通损害本平台利益的；<br>
                （2） 严重违反《服务需求确认单》中的服务要求的；<br>
                （3） 故意或重大过失给发包会员造成损害的；<br>
                （4） 与任一用人单位存在劳动关系的；<br>
                （5） 隐瞒、谎报个人情况的；<br>
                （6） 未按照《服务需求确认单》规定时限完成任务的；<br>
                （7） 擅自中止、终止任务的；<br>
                （8） 将本平台分包的任务转包他人的；<br>
                （9） 不能胜任任务的；<br>
                （10）    因犯罪被追究法律责任的；<br>
                （11）    本规则规定的其他情形。<br>
                鉴于以上（1）至（10）项均为违约行为，分包会员还应承担违约责任。
            </p>
            <p>
                <span class="ui-interval">5.2</span>
                发包会员有下列行为之一的，分包会员有权取消相应的任务：<br>
                （1） 拒绝提供应当由发包会员提供的实施任务所必需的相关条件；<br>
                （2） 要求从事违反法律法规或有害公序良俗的行为；<br>
                （3） 要求进行危及人身安全的作业。
            </p>
            <div class="sub-title">
                <span class="ui-interval">第六条</span>附则
            </div>
            <p>
                <span class="ui-interval">6.1</span>
                本规则下列用语的定义：<br>
                （1）“发包会员”：指将向本平台外包任务，本平台自行或以分包方式承接其任务的企业会员。<br>
                （2）“分包会员”：指本平台将所承接的任务分包，承接本平台分包任务的个人会员。<br>
                （3）“任务”指企业会员外包给本平台的《服务需求确认单》中的服务内容或本平台分包给个人会员的《服务需求确认单》中的服务内容。
            </p>
            <p>
                <span class="ui-interval">6.2</span>
                下列表单格式作为本规则附件，构成本规则的组成部分：<br>
                （1）《服务需求确认单》；<br>
                （2）《服务成果确认书》；<br>
                （3）《服务报酬结算申请单》；<br>
                （4）《授权委托书》。
            </p>
            <p>
                <span class="ui-interval">6.3</span>
                对于个人会员，本规则作为《会员注册协议》的组成部分，《会员注册协议》正文如与本规则有不一致之处，以本规则规定为准。
            </p>
            <p>
                <span class="ui-interval">6.4</span>
                个人会员在注册成为本平台会员前已与本平台运营方线下签署服务分包合同的，自注册成为本平台会员之日起，原服务分包合同解除，相关权利义务按照《会员注册协议》及本规则确定，但依据原服务分包合同已实施的任务仍适用原服务分包合同。
            </p>
            <p>
                <span class="ui-interval">6.5</span>
                本规则自本平台公布之日起施行。
            </p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Agreement'
}
</script>

<style scoped lang="scss">
    .container {
        background-color: #fff;
        padding: 60px 100px;

        .header {
            text-align: center;
            font-size: 20px;
            color: #333;
            font-weight: 600;
            margin-bottom: 35px;
        }

        .sub-title {
            margin: 35px 0;
            font-size: 16px;
            font-weight: 600;

            .ui-interval {
                margin-right: 20px;
            }
        }
        .underline {
            display: inline-block;
            border-bottom: 1px solid #666;
            margin: 0 4px;
            &.letter-2 {
                width: 2em;
            }
            &.letter-20 {
                width: 20em;
            }
        }
        p {
            margin-bottom: 0;
            line-height: 2;

            .ui-interval {
                margin-right: 14px;
            }
        }
    }
</style>
